$(document).ready(function () {

    const headerOffset = 68;

    function scrollToTarget(targetId) {
        const $target = $(targetId);

        if ($target.length) {
            const offsetTop = $target.offset().top - headerOffset;

            $('html, body').stop().animate({
                scrollTop: offsetTop
            }, 600);
        }
    }

    // 👉 click buttons with anchors
    $('.btn-primary, .btn-with-border').on('click', function (e) {
        const href = $(this).attr('href');

        if (!href) return;

        if (href.indexOf('#') !== -1) {
            const hash = href.substring(href.indexOf('#'));

            if (window.location.pathname === this.pathname || this.pathname === '') {
                e.preventDefault();
                scrollToTarget(hash);
            }
        }
    });

    if (window.location.hash) {
        setTimeout(function () {
            scrollToTarget(window.location.hash);
        }, 300);
    }
});